'use client'

import dynamic from 'next/dynamic'

export function NewsletterModalLoader({ template }: { template: string | null }) {
  const NewsletterModal = dynamic(
    () =>
      import(`@/components/${template}/global/newsletter-modal`).catch(() => {
        return Promise.resolve(() => null)
      }),
    { ssr: false }
  )

  return <NewsletterModal />
}
